/***********************
 * DEFAULT SORT (iOS Optimized)
 ***********************/
function setDefaultSort() {
  const sortElement = document.getElementById("junipReviewSort");
  if (!sortElement) return false;

  let modified = false;
  [...sortElement.options].forEach(opt => {
    if (!["mostHelpful", "mostRecent"].includes(opt.value)) {
      opt.remove();
      modified = true;
    }
  });

  if (modified) {
    // Crucial for iOS/mobile select elements to register the option changes
    sortElement.dispatchEvent(new Event('change', { bubbles: true }));
  }

  console.log("Q114 NEW! firing setDefaultSort");
  return true;
}

/***********************
 * ROBUST CLICK HELPER FOR IOS
 ***********************/
function simulateIOSClick(element) {
  if (!element) return;
  
  // Create a proper MouseEvent that iOS WebKit will respect and bubble up
  const mouseEvent = new MouseEvent('click', {
    view: window,
    bubbles: true,
    cancelable: true,
    clientX: element.getBoundingClientRect().left + 5,
    clientY: element.getBoundingClientRect().top + 5
  });
  
  element.dispatchEvent(mouseEvent);
}

/***********************
 * Initialize
 ***********************/
document.addEventListener("DOMContentLoaded", () => {
  let toggleHandled = false;
  let sortHandled = false;

  const observer = new MutationObserver(() => {
    const toggle = document.querySelector(".junip-filters-toggle");
    const sort = document.getElementById("junipReviewSort");

    if (toggle && !toggle.dataset.clicked) {
      toggle.dataset.clicked = "true";
      simulateIOSClick(toggle);
      toggleHandled = true;
    }

    if (sort && !sortHandled && setDefaultSort()) {
      sortHandled = true;
    }

    if (toggleHandled && sortHandled) {
      observer.disconnect();
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });

  // 3-Second Fallback Safety Net
  setTimeout(() => {
    const toggle = document.querySelector(".junip-filters-toggle");
    if (toggle && toggle.dataset.clicked !== "true") {
      toggle.dataset.clicked = "true";
      simulateIOSClick(toggle);
    }
    setDefaultSort();
    observer.disconnect();
  }, 3000);

  // Click Delegation for Container Check
  document.addEventListener("click", event => {
    if (event.target.closest(".junip-filters-toggle.junip-btn")) {
      setTimeout(() => {
        if (document.querySelector(".junip-filters-container")) {
          setDefaultSort();
        }
      }, 500);
    }
  });
});